import { FilterTypeENUM } from 'components/Filters/0_FilteraCollection/Filters.model'
import {
  DEFAULT_FIRST_PAGE_PAGINATOR,
  DEFAULT_OBJECTS_PER_PAGE,
} from 'numberConsts/numberConsts'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { SearchInput } from '../../../components/Search/SearchInput'
import { SLink } from '../../../MainContainer/PagesList/PagesList.styled'
import { FilterWrapper } from '../../../pages/map/style/FilterWrapper.styled'
import type { RootState } from '../../../store/store'
import { queryParser } from '../../../utils/utils'
import { FiltersMainMenu } from './components/Filters/FiltersMainMenu'
import {
  SFilterContent,
  SFilterWrapp,
  SInput,
  SMapPosition,
  STitle,
  STitleWrapp,
  SWrappSpaceBlock,
} from './MainMenu.styled'
import { RadioGroup } from './RadioGroup'

export const MainMenu = () => {
  const [activeFilterType, setActiveFilterType] = useState<
    FilterTypeENUM.eventsFilters | FilterTypeENUM.programsFilters
  >(FilterTypeENUM.programsFilters)
  const filters = useSelector((state: RootState) => state.filters)

  const mapQuery = {
    type:
      activeFilterType === FilterTypeENUM.eventsFilters ? 'events' : 'programs',
    ...queryParser(filters[activeFilterType]),
  }

  return (
    <SFilterWrapp>
      <SFilterContent>
        <STitleWrapp>
          <STitle>Что вас интересует?</STitle>
          <SMapPosition>
            <SLink href={{ pathname: '/map', query: mapQuery }}>На карте</SLink>
          </SMapPosition>
        </STitleWrapp>
        <SWrappSpaceBlock block>
          <SInput>
            <SearchInput />
            <FilterWrapper>
              <FiltersMainMenu
                onActiveTypeChange={setActiveFilterType}
                initialQuery={{
                  page: DEFAULT_FIRST_PAGE_PAGINATOR.toString(),
                  per_page: DEFAULT_OBJECTS_PER_PAGE.toString(),
                }}
              />
            </FilterWrapper>
          </SInput>
        </SWrappSpaceBlock>
        <RadioGroup />
      </SFilterContent>
    </SFilterWrapp>
  )
}
